import type { V1UserRequestModel } from '@/shared/api'

const HIDDEN_NAME = '***'

export const getDriverFullName = (userRequest?: V1UserRequestModel) => {
    if (!userRequest || !userRequest.is_active) {
        return HIDDEN_NAME
    }

    const { last_name, first_name, middle_name } = userRequest
    const isEmpty = [last_name, first_name, middle_name].every((name) => name === '')

    if (isEmpty) {
        return HIDDEN_NAME
    }

    return `${last_name} ${first_name} ${middle_name}`
}
